import { publicConfig } from './config'
import { trackConversion } from './analytics'

export function Arrow() {
  return <svg aria-hidden="true" viewBox="0 0 24 24" fill="none"><path d="M5 19 19 5M6 5h13v13" stroke="currentColor" strokeWidth="1.5" /></svg>
}

export function ApplyLink({ location, compact = false, light = false }: { location: string; compact?: boolean; light?: boolean }) {
  return <a className={`button ${light ? 'button--light' : 'button--primary'}`} href={publicConfig.registrationUrl} target="_blank" rel="noopener noreferrer" aria-label="กรอกใบสมัครผ่าน Google Form (เปิดแท็บใหม่)" onClick={() => trackConversion('cta_click', location)}>{compact ? 'สมัครเลย' : 'สมัครผ่าน Google Form'}<Arrow /></a>
}

export function SectionLabel({ number, children }: { number: string; children: string }) {
  return <p className="section-label"><span>{number}</span>{children}</p>
}

export function WellnessIcon({ name }: { name: string }) {
  const paths: Record<string, string> = {
    body: 'M3 12h4l3-8 4 16 3-8h4',
    growth: 'M5 19 19 5M8 5h11v11M5 12v7h7',
    confidence: 'M12 20S3 14 3 8a5 5 0 0 1 9-3 5 5 0 0 1 9 3c0 6-9 12-9 12Z',
    community: 'M9 11a4 4 0 1 0 0-8 4 4 0 0 0 0 8ZM2 21v-3a5 5 0 0 1 5-5h4a5 5 0 0 1 5 5v3M17 4a4 4 0 0 1 0 7M18 14a5 5 0 0 1 4 5v2',
    world: 'M12 2a10 10 0 1 0 0 20 10 10 0 0 0 0-20ZM2 12h20M12 2c-6 5-6 15 0 20M12 2c6 5 6 15 0 20',
  }
  return <svg aria-hidden="true" viewBox="0 0 24 24" fill="none"><path d={paths[name] || paths.growth} stroke="currentColor" strokeWidth="1.3" strokeLinecap="round" strokeLinejoin="round" /></svg>
}
